import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { resetInitialHistoryLoaded } from '../state/slices/integrationSlice';
import {
  fetchConnectedDevices,
  fetchDeviceDataByTimestamps,
  fetchDeviceTypeMap,
  fetchSystemTypeMap,
} from '../state/thunks';

const DAY_IN_MS = 24 * 60 * 60 * 1000;

export default function useIntegrationInit({ enabled = true } = {}) {
  const dispatch = useDispatch();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      startedRef.current = false;
      // Reset initial history loaded flag when user logs out
      dispatch(resetInitialHistoryLoaded());
    }
  }, [enabled, dispatch]);

  useEffect(() => {
    if (!enabled || startedRef.current) return;
    startedRef.current = true;

    const init = async () => {
      // Load integration baselines once after auth.
      await Promise.all([
        dispatch(fetchDeviceTypeMap()),
        dispatch(fetchSystemTypeMap()),
        dispatch(fetchConnectedDevices()),
      ]);

      const endTime = Date.now();
      // Load a 1-day initial snapshot (request just one day by default)
      const startTime = endTime - DAY_IN_MS;
      // Pull the initial 1-day device history snapshot.
      dispatch(fetchDeviceDataByTimestamps({ startTime, endTime }));
    };

    init();
  }, [dispatch, enabled]);
}
